export default {"src":"/_next/static/media/eye.889cdb9a.svg","height":11,"width":17,"blurWidth":0,"blurHeight":0};